export const getShortenedString = (string, length) => {
    if (!string)
        return '';
    if (string.length <= length)
        return string;
    const result = string.substring(0, length);
    return `${result}...`;
};
export const capitalize = (str) => (str.length ? str[0].toUpperCase() + str.substring(1) : '');
export const decapitalize = (str) => (str.length ? str[0].toLowerCase() + str.substring(1) : '');
export const validateByCharacters = (text, usingReg) => ({
    valid: !usingReg.test(text),
    value: text.replace(usingReg, '')
});
export const allowComaToDecimal = (value = '') => `${value || ''}`.replaceAll(',', '.');
export const snakeToCamel = (str) => {
    const words = str.split('_');
    return words.reduce((acc, word) => {
        return `${acc}${capitalize(word)}`;
    }, '');
};
